<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="title"
        class="customer-edit"
        width="1200px"
        top="2vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="formData"
          :rules="ruleValidate"
          class="form"
          :disabled="isView"
          label-width="100px">
        <div class="section-title">
          基本信息
        </div>
        <el-row>
          <el-col :span="6">
            <el-form-item label="订单编号">
              <el-input v-model="formData.salesOrderNO" readonly placeholder="系统自动生成"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单类型" prop="salesOrderCategory">
              <el-select v-model="formData.salesOrderCategory" clearable placeholder="请选择">
                <el-option label="标准订单" :value="0"/>
                <el-option label="改造订单" :value="70"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="项目类型" prop="subContract">
              <el-select v-model="formData.subContract" clearable placeholder="请选择">
                <el-option label="国内项目" value="国内项目"/>
                <el-option label="国外项目" value="国外项目"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="formData.customerName" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="formData.projectName" placeholder="请输入项目名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同编号" prop="clientContractNO">
              <el-input v-model="formData.clientContractNO" placeholder="请输入合同编号"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="要求发货日期" prop="deliveryDate">
              <el-date-picker
                  v-model="formData.deliveryDate"
                  type="date"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择要求发货日期"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="运输方式" prop="transportType">
              <el-select v-model="formData.transportType" clearable placeholder="请选择">
                <el-option label="汽车运输" :value="0"/>
                <el-option label="铁路运输,乙方负责将甲方订购的合同产品送至上海站发运" :value="1"/>
                <el-option label="甲方提供" :value="2"/>
                <el-option label="其它" :value="3"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="包装箱选择" prop="shippingMark">
              <el-select v-model="formData.shippingMark" clearable placeholder="请选择">
                <el-option label="木箱" value="木箱"/>
                <el-option label="纸箱" value="纸箱"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否有特殊包装要求" prop="packingBox" label-width="160px">
              <el-radio-group v-model="formData.packingBox">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="外贴面颜色" prop="surfaceColor" :rules="[{ required: formData.shippingMark === '木箱', message: '不能为空' }]">
              <el-select
                  v-model="formData.surfaceColor"
                  :disabled="!(formData.shippingMark === '木箱')"
                  clearable
                  placeholder="请选择">
                <el-option label="红皮（一般标准）" value="红皮（一般标准）"/>
                <el-option label="白皮" value="白皮"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="LOGO" prop="logo" :rules="[{ required: formData.shippingMark === '木箱', message: '不能为空' }]">
              <el-select
                  v-model="formData.logo"
                  :disabled="!(formData.shippingMark === '木箱')"
                  clearable
                  placeholder="请选择">
                <el-option label="客户专用" value="客户专用"/>
                <el-option label="STEP空白木箱" value="STEP空白木箱"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分箱要求" prop="packingType" :rules="[{ required: formData.shippingMark === '木箱', message: '不能为空' }]">
              <el-select v-model="formData.packingType" :disabled="!(formData.shippingMark === '木箱')" clearable placeholder="请选择">
                <el-option label="整体包装" value="整体包装"/>
                <el-option label="线缆单包" value="线缆单包"/>
                <el-option label="控制柜单包" value="控制柜单包"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="送货地点" prop="deliveryPlace">
              <el-select v-model="formData.deliveryPlace" clearable placeholder="请选择" @change="handleDeliveryPlaceChange">
                <el-option
                    v-for="item in deliveryAddresses"
                    :key="item.pkid"
                    :label="item.addressDetail"
                    :value="item.addressDetail"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="formData.contact" placeholder="请输入联系人"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话" prop="telephone">
              <el-input v-model="formData.telephone" placeholder="请输入联系电话"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="包装备注" prop="packingNote">
              <el-input v-model="formData.packingNote" type="textarea" placeholder="请输入包装备注"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="订单备注" prop="note">
              <el-input v-model="formData.note" type="textarea" placeholder="请输入订单备注"/>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 商品属性 -->
        <div class="section-title">
          参数配置
        </div>
        <div v-for="(material, index) in formData.salesOrderMaterialVOes" :key="index">
          <div class="shop-pro-title">
            <span>{{material.materialName}}</span>
            <el-button 
                type="text" 
                size="small" 
                style="margin-left: 10px;"
                @click="toggleExpand(index)">
              {{expandedItems[index] ? '收起' : '展开'}}
            </el-button>
          </div>
          <div :class="['shop-pro-item', {'shop-pro-item-expanded': !expandedItems[index]}]">
            <product-property
                :ref="`productProperty${index}`"
                :product-list="material.salesOrderMaterialPropertyVOes"
                :disabled="isView"
                @UpdateProductForm="(data) => updateProductForm(data, index)"
                @change="handleChange(index)"
                @selectChange="handleSelectChange(index)"
            />
          </div>
        </div>

        <!-- 发票信息 -->
        <div class="section-title">
          发票信息
        </div>
        <div class="invoice-info">
          <el-row>
            <el-col :span="16">
              <el-form-item label="发票类型" prop="invoiceType">
                <el-radio-group v-model="formData.invoiceType">
                  <el-radio :label="0">增值税发票</el-radio>
                  <el-radio :label="1">普通发票</el-radio>
                  <el-radio :label="2">不要发票</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="发票抬头" prop="invoiceName">
                <el-input v-model="formData.invoiceName" disabled placeholder="请输入发票抬头"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="账号" prop="invoiceAccounts">
                <el-input v-model="formData.invoiceAccounts" disabled placeholder="请输入账号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="税号" prop="invoiceVATNO">
                <el-input v-model="formData.invoiceVATNO" disabled placeholder="请输入税号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开户银行" prop="invoiceBank">
                <el-input v-model="formData.invoiceBank" disabled placeholder="请输入开户银行"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="电话" prop="phone">
                <el-input v-model="formData.phone" disabled placeholder="请输入电话"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="地址" prop="invoiceAddress">
                <el-input v-model="formData.invoiceAddress" disabled placeholder="请输入地址"/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        
        <!-- 确认订单信息 -->
        <div class="section-title">
          确认订单
        </div>
        <div style="padding: 0 0 10px 10px;margin: 0 auto">
          <el-table :data="formData.salesOrderMaterialVOes" border show-summary :summary-method="getSummaries">
            <el-table-column prop="materialName" align="left" label="产品名称"/>
            <el-table-column prop="price" width="200" align="right" label="金额">
              <template slot-scope="scope">
                ¥ <span style="color: red; font-weight: bold;">{{commonUtil.formatNumberToLocale((parseFloat(scope.row.price) * parseFloat(scope.row.quantity)).toFixed(2))}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" width="160" align="center" label="数量">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.quantity" :min="1" placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <div class="section-title">
            附件上传
          </div>
          <div>
            <el-upload
                action=""
                multiple
                :http-request="submitUpload"
                :show-file-list="false"
                :disabled="uploadLoading"
                style="display: inline-block; margin: 5px;">
              <el-button type="primary" plain>
                <i class="el-icon-upload el-icon--right"/>
                附件上传
              </el-button>
            </el-upload>
          </div>
          <el-table v-if="formData.salesOrderAttachmentVOes" ref="payData" :data="formData.salesOrderAttachmentVOes">
            <el-table-column type="index" align="center" label="行号" width="60"/>
            <el-table-column prop="fileName" align="center" label="附件名称"/>
            <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.$index)">删除</el-button>
                <el-button type="primary" @click="fileDownload(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <template v-if="!isView">
          <el-button :loading="saveLoading" type="primary" @click="handleSave">保存</el-button>
          <!-- <el-button :loading="submitLoading" type="success" @click="handleSubmit">提交</el-button> -->
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import auth from "@/util/loginUtil";
  import ProductProperty from "@/views/main/components/ProductProperty.vue";
  import commonUtil from "@/util/commonUtil";
  const userProfile = auth.getUserInfo().userProfile || {};
  export default {
    name: "DisassembleOrderEdit",
    components: {  ProductProperty },  
    data() {
      return {
        isView: false, // 是否查看详情
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        saveLoading: false,
        uploadLoading: false,
        commonUtil,
        selection: [],
        imgUrls: [],
        cartIds: [],
        title: "新增订单",
        formData: {
          pKID: "",
          clientType: 10,
          salesOrderNO: "", // 订单编号
          salesOrderCategory: "", // 订单类型 70 非改造订单；0 改造订单，
          subContract: "", // 项目类型
          customerName: userProfile.name || "", // 客户名称
          customerID: userProfile.companyID || "", // 客户ID
          projectName: "", // 项目名称
          clientContractNO: "", // 客户合同编号
          deliveryDate: "", // 计划交货日期
          transportType: "", // 运输方式
          shippingMark: "", // 包装箱选择
          packingBox: "", // 特殊包装要求
          packingType: "", // 分箱要求
          surfaceColor: "", // 表面颜色
          logo: "", // LOGO
          contact: "", // 联系人
          telephone: "", // 联系电话
          deliveryPlace: "", // 配送地址ID
          packingNote: "", // 包装备注
          note: "", // 项目备注
          invoiceType: 0, // 发票类型
          invoiceName: "", // 发票名称
          invoiceAccounts: "", // 发票账号
          invoiceVATNO: "", // 发票税号
          invoiceBank: "", // 发票银行
          phone: "", // 联系电话
          invoiceAddress: "", // 发票地址
          salesOrderAttachmentVOes: [],
          materialProperties: [], // 商品属性
          salesOrderMaterialVOes: [], // 订单列表
        },
        ruleValidate: {
          salesOrderNO: {required: true, message: "不能为空", trigger: ["blur"]},
          salesOrderCategory: {required: true, message: "不能为空", trigger: ["blur"]},
          subContract: {required: true, message: "不能为空", trigger: ["change"]},
          customerName: {required: true, message: "不能为空", trigger: ["blur"]},
          projectName: {required: true, message: "不能为空", trigger: ["blur"]},
          clientContractNO: {required: true, message: "不能为空", trigger: ["blur"]},
          deliveryDate: {required: true, message: "不能为空", trigger: ["blur"]},
          transportType: {required: true, message: "不能为空", trigger: ["blur"]},
          shippingMark: {required: true, message: "不能为空", trigger: ["change"]},
          deliveryPlace: {required: true, message: "不能为空", trigger: ["change"]},
          contact: {required: true, message: "不能为空", trigger: ["blur"]},
          telephone: {required: true, message: "不能为空", trigger: ["blur"]},
          packingNote: {required: true, message: "不能为空", trigger: ["blur"]},
          note: {required: true, message: "不能为空", trigger: ["blur"]},
        },
        deliveryAddresses: [], // 配送地址
        expandedItems: {}, // 控制商品属性展开收起状态
        pickerOptions: {
          disabledDate(time) {
            // 确保time是Date对象
            if (!(time instanceof Date)) {
              return false;
            }
            return time.getTime() < Date.now() - 8.64e7; // 禁用今天之前的日期
          },
        },
      };
    },
    methods: {
      async open({ id, orderType, isView, cartIds, cartList, templateIds, title }) {
        if(title) {
          this.title = title;
        } else if(id && isView) {
          this.title = "查看订单";
        } else if((cartIds && cartIds.length > 0) || (templateIds && templateIds.length > 0)) {
          this.title = "新增订单";
        } else {
          this.title = "编辑订单";
        }
        // 如果是详情，则禁用所有输入框
        this.isView = isView;
        this.cartIds = cartIds;
        this.dialogVisible = true;
        // this.clearValidate();
        if (cartIds) {
          // 代表从购物车来新增订单
          await this.getDataByCart(orderType, cartList);
        }
        if(templateIds) {
          // 代表从模板来新增订单
          await this.getDataByTemplate(orderType, templateIds);
        }
        if (id) {
          // 代表从订单详情来编辑订单
          await this.getDataByOrderId(id);
          return; // 详情不需要请求客户地址列表了
        }
        this.getCustomerRelatedInfo(this.formData.customerName);
      },
      // 获取用户相关信息
      getCustomerRelatedInfo() {
        this.contentLoading = true;
        this.$http
          .get("basic", `customers/${this.formData.customerID}`)
          .then(resp => {
            const data = resp || {};
            this.deliveryAddresses = data.customerDeliveryAddresses || []; // 送货地址
            this.formData.invoiceName = data.customerName; // 发票名称
            this.formData.invoiceAccounts = data.accounts; // 发票账号
            this.formData.invoiceVATNO = data.vatno; // 发票税号
            this.formData.invoiceBank = data.bank; // 发票银行
            this.formData.phone = data.mobile; // 联系电话
            this.formData.invoiceAddress = data.invoiceAddress; // 发票地址
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      // 根据购物车创建订单
      getDataByCart(orderType, cartList) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sd/so/createOrder/${this.cartIds}`)
          .then(resp => {
            this.formData = resp.data || {};
            this.formData.deliveryDate = this.formData.deliveryDate ? new Date(this.formData.deliveryDate) : null;
            this.formData.salesOrderCategory = orderType; // 要从外面选择带入这个类型
            this.formData.salesOrderMaterialVOes.forEach(item => {
              const index = cartList.findIndex(cart => cart.pkid === item.shoppingCartId);
              if (index !== -1) {
                item.quantity = cartList[index].quantity;
              }
            });
            this.handleImgUrl();
          }).finally(() => {
            this.contentLoading = false;
          });
      },
      // 根据订单模板创建订单
      getDataByTemplate(orderType, templateIds) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sd/so/createOrder/template/${templateIds}`)
          .then(resp => {
            this.formData = resp.data || {};
            this.formData.deliveryDate = this.formData.deliveryDate ? new Date(this.formData.deliveryDate) : null;
            this.formData.salesOrderCategory = orderType; // 要从外面选择带入这个类型
            this.handleImgUrl();
          }).finally(() => {
            this.contentLoading = false;
          });
      },
      // 获取订单详情
      getDataByOrderId(id) {
        this.$http
          .get("basic", `sd/so/${id}/0`)
          .then(resp => {
            this.formData = resp.data || {};
            this.handleImgUrl();
          });
      },
      // 跟新用户信息及送货地址ID
      handleDeliveryPlaceChange(val) {
        const item = this.deliveryAddresses.filter(item => item.addressDetail === val)[0];
        if (item) {
          this.formData.contact = item.contact; // 联系人
          this.formData.telephone = item.telephone; // 联系电话
        }
      },
      // 更新商品属性
      updateProductForm(newForm, index) {
        this.formData.salesOrderMaterialVOes[index].salesOrderMaterialPropertyVOes = newForm;
      },
      // 商品属性改变时触发
      handleChange(index) {
        this.handleQuery();
        this.$http.post("basic", "sd/so/rule/set", this.formData).then(res => {
          const { success, data } = res || {};
          if (success) {
            this.updateProductForm(data.detailVOList, index);
            if(this.$refs.productProperty) {
              this.$refs.productProperty.freshFormData(data.detailVOList);
            }
          }
        });
      },
      // 商品属性改变时触发
      handleSelectChange(index) {
        this.handleQuery();
        this.$http.post("basic", "sd/so/price/set", this.formData).then(res => {
          this.formData = res.data || {};
          this.handleImgUrl();
        });
      },

      // 删除文件
      fileDelete(index) {
        this.formData.salesOrderAttachmentVOes.splice(index, 1);
      },
      //附件下载
      fileDownload(row) {
        let str = row.filePath.slice(0, 1);
        if (str === "~") {
          let url = window.config.fileServerUrl + row.filePath.replace("~", "");
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        } else {
          let data = {
            name: row.fileName,
            uuid: row.filePath,
          };
          this.$http
            .exportFile("basic", "file/download", data)
            .then((res) => {
              let blob = new Blob([res.data], { type: "application" });
              let fileName = decodeURI(res.config.params.name);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              // this.downLoadLoading = false;
            })
            .catch(() => {
              // this.downLoadLoading = false;
              this.$message.error("下载失败");
            });
        }
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            const {success, data} = res || {};
            if (success) {
              this.uploadLoading = false;
              const fileInfo = data.attachments[0];
              if (!this.formData.salesOrderAttachmentVOes) {
                this.formData.salesOrderAttachmentVOes = [];
              }
              this.formData.salesOrderAttachmentVOes.push({
                rowIndex: this.formData.salesOrderAttachmentVOes.length,
                fileName: fileInfo.fileName,
                filePath: "/attached/file/" + fileInfo.filePath,
                attachmentType: fileInfo.itemType,
                fileData: fileInfo.fileByte,
              });
              this.handleImgUrl();
              this.$message.success("上传成功");
            }
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      handleImgUrl() {
        (this.formData.salesOrderAttachmentVOes || []).forEach(row => {
          if (row.filePath.includes("common")) {
            row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
            this.imgUrls.push(row.imgUrl);
          } else {
            row.imgUrl = "https://emes.stepelectric.com/" + row.filePath;
            this.imgUrls.push(row.imgUrl);
          }
        });
      },
      clearValidate() {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
          for (let i = 0; i < this.formData.salesOrderMaterialVOes.length; i++) {
            const productPropertyRef = this.$refs[`productProperty${i}`];
            if (productPropertyRef) {
              productPropertyRef.clearValidate();
            }
          }
        });
      },
      // 提交
      async handleSubmit() {
        this.$refs.form.validate(async valid => {
          if (valid) {
            // 验证所有产品属性组件
            let allValid = true;
            
            for (let i = 0; i < this.formData.salesOrderMaterialVOes.length; i++) {
              const productPropertyRef = this.$refs[`productProperty${i}`];
              if (productPropertyRef && productPropertyRef[0].handleValidate) {
                const propertyValid = await productPropertyRef[0].handleValidate();
                if (!propertyValid) {
                  allValid = false;
                  break;
                }
              }
            }
            
            if (allValid) {
              this.saveLoading = true;
              this.formData.salesOrderMaterialVOes.forEach((item, index) => {
                this.$refs[`productProperty${index}`][0].updateProductForm();
                item.salesOrderCategory = this.formData.salesOrderCategory;
              });
              this.$http
                .post("basic", "sd/so/submit", this.formData)
                .then((res) => {
                  if (res.success) {
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("提交成功");
                  } else {
                    this.$message.error("提交失败");
                  }
                })
                .finally(() => {
                  this.saveLoading = false;
                });
            } else {
              this.$message.warning("请填写所有必填项");
            }
          }
        });
      },
      handleQuery() {
        let totalMoney = 0;
        this.formData.salesOrderMaterialVOes.forEach((item, index) => {
          this.$refs[`productProperty${index}`][0].updateProductForm();
          item.salesOrderCategory = this.formData.salesOrderCategory;
          totalMoney += parseFloat(item.price) * parseFloat(item.quantity);
        });
        this.formData.totalMoney = totalMoney;
        this.formData.clientType = 10;
        this.formData.specialPacking = true;
        this.formData.structure = "";
      },
      // 保存订单
      async handleSave() {
        this.$refs.form.validate(async valid => {
          if (valid) {
            // 验证所有产品属性组件
            let allValid = true;
            
            for (let i = 0; i < this.formData.salesOrderMaterialVOes.length; i++) {
              const productPropertyRef = this.$refs[`productProperty${i}`];
              if (productPropertyRef && productPropertyRef[0].handleValidate) {
                const propertyValid = await productPropertyRef[0].handleValidate();
                if (!propertyValid) {
                  allValid = false;
                  break;
                }
              }
            }
            
            if (allValid) {
              this.saveLoading = true;
              this.handleQuery();
              this.$http
                .post("basic", "sd/so", this.formData)
                .then((res) => {
                  if (res.success) {
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  } else {
                    this.$message.error(res.message || "保存失败");
                  }
                })
                .finally(() => {
                  this.saveLoading = false;
                });
            } else {
              this.$message.warning("请填写所有必填项");
            }
          }
        });
      },
      // 表格合计
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          if (["price"].includes(column.property)) {
            const values = data.map(item => Number(item[column.property]) * parseFloat(item.quantity));
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = "¥ " + commonUtil.formatNumberToLocale(parseFloat(sums[index]).toFixed(2));
          } else {
            sums[index] = "";
          }
        });

        return sums;
      },
      // 切换商品属性展开收起状态
      toggleExpand(index) {
        this.$set(this.expandedItems, index, !this.expandedItems[index]);
      },
    },
  };
</script>

<style lang="scss" scoped>
.shop-pro-title{
  // margin-bottom: 5px;
  padding-left: 20px;
  font-weight: bold;
}
.shop-pro-item {
  margin-bottom: 20px;
  border-top: 1px dashed #e4e7ed;
  padding-top: 10px;
  height: auto;
  &.shop-pro-item-expanded {
    height: 30px;
    overflow: hidden;
  }
}
.section-title {
  border-bottom: 1px solid #ddd;
    margin-bottom: 10px;
    padding-bottom: 5px;
    font-size: 16px;
    margin-top: 20px;
    font-weight: bold;
}
.el-date-editor {
  width: 100%;
}
.el-radio{
  line-height: 27.2px;
}
</style>
